import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTextFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={32}
    height={32}
    fill='none'
    {...props}
  >
    <rect width={32} height={32} fill='url(#textFile_svg__a)' rx={6} />
    <defs>
      <pattern id='textFile_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#textFile_svg__b' transform='scale(.00195)' />
      </pattern>
      <image
        xlinkHref='/images/icons/text-file-ca86f264.webp'
        id='textFile_svg__b'
        width={512}
        height={512}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgTextFile;
